var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngagementIcon = function SvgEngagementIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19,
    viewBox: "0 0 23 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "m18.5 12.922-.03-7.914a.51.51 0 0 0-.502-.508H3.998a.496.496 0 0 0-.498.497v8.02c0 .268.228.496.5.496h2.503v2.357c0 .164-.038.142.105.057l4.201-2.5h7.19a.505.505 0 0 0 .501-.505M4 14.513c-.825 0-1.5-.677-1.5-1.497v-8.02c0-.827.669-1.496 1.499-1.496h13.97c.827 0 1.499.675 1.502 1.505l.029 7.913a1.505 1.505 0 0 1-1.5 1.509h-6.916l-3.964 2.36c-.808.48-1.617.024-1.617-.917v-1.357z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.107,
    cy: 9.107,
    r: 1.107
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.107,
    cy: 9.107,
    r: 1.107
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.107,
    cy: 9.107,
    r: 1.107
  }))));
};
export default SvgEngagementIcon;